export const iconFontAwesomeSecurityMask = (
	<i className="fa-solid fa-mask"></i>
);
